// 登录页面专用AES加密工具类
// 只包含加密功能，不实现解密
import CryptoJS from 'crypto-js';

/**
 * 生成当前时间戳(毫秒)
 * @returns {string} 时间戳字符串
 */
export function generateTimestamp() {
	return Date.now().toString();
}

/**
 * AES加密函数 - 专门用于登录场景
 * @param {string} text 需要加密的文本(通常是时间戳)
 * @param {string} key 加密密钥(16/24/32位)
 * @param {string} iv 偏移量(16位)
 * @returns {string|boolean} 加密后的字符串，失败返回false
 */
export function aesEncrypt(text, key, iv) {
	// 验证输入
	if (!text || !key || !iv) {
		console.error('AES加密失败：缺少必要参数');
		return false;
	}
	
	// 验证密钥长度
	const keyLength = key.length;
	if (![16, 24, 32].includes(keyLength)) {
		console.error(`AES加密失败：密钥长度必须是16、24或32位，当前为${keyLength}位`);
		return false;
	}
	
	// 验证偏移量长度
	if (iv.length !== 16) {
		console.error(`AES加密失败：偏移量必须是16位，当前为${iv.length}位`);
		return false;
	}
	
	try {
		// 将密钥和偏移量转换为WordArray对象
		const keyHex = CryptoJS.enc.Utf8.parse(key);
		const ivHex = CryptoJS.enc.Utf8.parse(iv);
		
		// 加密 - 使用CBC模式和Pkcs7填充
		const encrypted = CryptoJS.AES.encrypt(text, keyHex, {
			iv: ivHex,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7
		});
		
		// 返回Base64格式的加密结果
		return encrypted.toString();
	} catch (error) {
		console.error('AES加密过程出错：', error);
		return false;
	}
}
